/**
 * SignIn Page
 * 
 * Authentication page for user sign-in with SSO.
 * Supports dark/light themes and responsive design.
 */

import { SignInLayout } from '../features/auth/components/SignInLayout';
import { AuthCard } from '../shared/components/ui/AuthCard';
import { SignInForm } from '../features/auth/components/SignInForm';
import { SignInErrorModal } from '../features/auth/components/SignInErrorModal';
import { useSignIn } from '../features/auth/hooks/useSignIn';

/**
 * SignIn page component
 */
export function SignIn() {
  const {
    email,
    password,
    isLoading,
    error,
    setEmail,
    setPassword,
    handleSignIn,
    clearError,
  } = useSignIn();

  return (
    <SignInLayout>
      <AuthCard 
        title="Sign in"
      >
        <SignInForm
          email={email}
          password={password}
          onEmailChange={setEmail}
          onPasswordChange={setPassword}
          onSubmit={handleSignIn}
          isLoading={isLoading}
        />
      </AuthCard>

      <SignInErrorModal
        isOpen={!!error}
        onClose={clearError}
      />
    </SignInLayout>
  );
}

export default SignIn;
